"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const TooltipContainer_1 = __importDefault(require("components/shared/Tooltips/TooltipContainer"));
const isTruncated = (el) => {
    var _a;
    if (el && (el === null || el === void 0 ? void 0 : el.parentElement)) {
        return (el === null || el === void 0 ? void 0 : el.scrollWidth) > ((_a = el === null || el === void 0 ? void 0 : el.parentElement) === null || _a === void 0 ? void 0 : _a.offsetWidth);
    }
};
const TruncateParagraph = ({ children, classContainer = '', className, textStyle = {}, position, dataCy, useMaxWidth = false, align, onClick = () => null }) => {
    const [showTooltip, setShowTooltip] = (0, react_1.useState)(false);
    const setTruncated = (0, react_1.useCallback)((ref) => {
        if (ref) {
            if (isTruncated(ref)) {
                setShowTooltip(true);
            }
        }
    }, []);
    return (react_1.default.createElement(TooltipContainer_1.default, { useMaxWidth: useMaxWidth, show: showTooltip, text: children, classContainer: `${showTooltip ? 'w-[100%]' : ''} ${classContainer}`, callbackRef: setTruncated, wrap: true, position: position, align: align },
        react_1.default.createElement("p", { "data-cy": dataCy, className: `${className ? className : ''} whitespace-nowrap ${showTooltip ? 'truncate' : ''}`, style: textStyle, onClick: onClick }, children)));
};
exports.default = TruncateParagraph;
